import useLocalStorage from './useLocalStorage'
import axios from 'axios'

import type { MerchantColors } from '@/types/types'
import type { LoyaltyMerchantFormColors } from '@/types/global'

export default function useMerchantColors() {
  const { user } = useLocalStorage()
  const { t } = useI18n()
  const notification = useNotification()

  const getMerchantColors = async (): Promise<MerchantColors> => {
    try {
      const { data } = await axios.get(`/merchants/${user.value.merchant.id}/colors`)
      return data.data
    } catch {
      notification.create('error', {
        text: t('pages.settings.merchantForm.notifications.get.merchantColorsError'),
        timeout: 3000
      })
    }
  }

  const merchantColorsForm = ref<LoyaltyMerchantFormColors>({
    background: {
      label: t('pages.settings.visualIdentity.backgroundsColor'),
      value: '#999dc4',
      type: 'color',
      rules: 'required'
    },
    text: {
      label: t('pages.settings.visualIdentity.textsColor'),
      value: '#000000',
      type: 'color',
      rules: 'required'
    },
    button: {
      label: t('pages.settings.visualIdentity.buttonsColor'),
      value: '#999dc4',
      type: 'color',
      rules: 'required'
    }
  })

  const formattedMerchantColorPayload = computed(() =>
    Object.entries(merchantColorsForm.value).reduce((acc, [key, obj]) => {
      acc[key] = obj.value.split('#')[1]
      return acc
    }, {})
  )

  const updateMerchantColors = async () => {
    try {
      await axios.put(`/merchants/${user.value.merchant.id}/colors`, formattedMerchantColorPayload.value)
    } catch {
      notification.create('error', {
        text: t('page.settings.visualIdentity.colorUpdateError'),
        timeout: 3000
      })
    }
  }

  return {
    getMerchantColors,
    merchantColorsForm,
    updateMerchantColors
  }
}
